module.exports = __webpack_public_path__ + "media/my_images/vision/SVG/text-15f8b27df2271f52be750ca847c84273.svg";